// extracted by mini-css-extract-plugin
export default {"main_container":"Account_main_container__Bh2iD","layout":"Account_layout__btGdQ"};